import { StyleSheet, Platform, Dimensions } from "react-native";
import * as Font from "expo-font";
import { BRAND_COLORS, BACKGROUND_COLORS } from "./colors";
const screenHeight = Dimensions.get("window").height;
export const styles = StyleSheet.create({
  containerNoColor: {
    flex: 1,
    // justifyContent: "center",
    // alignItems: "center",
  },
  container: {
    flex: 1,
    backgroundColor: BRAND_COLORS.ACCENT,
  },
  row: {
    flexDirection: "row",
    marginHorizontal: 10,
  },
  tableContainer: {
    marginTop: 10,
    padding: 10,
    maxHeight: 300,
    borderRadius: 5,
    marginBottom: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },

  tableContainerWeight: {
    marginTop: 10,
    padding: 10,
    flex: 1,
    maxHeight: "80vh",
    // width: "90%",
    borderRadius: 12,
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    padding: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 3,
    elevation: 5,
  },

  tableTitleContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  tableTitleContainerLeft: {
    flexDirection: "row",
    justifyContent: "left",
    alignItems: "left",
  },

  tableLeft: {
    backgroundColor: "#456369",
    marginRight: 10,
  },
  tableRight: {
    backgroundColor: "#456369",
  },
  tableTitle: {
    backgroundColor: "#2A373C", // Cambiar a un verde más oscuro
    fontSize: 18,
    fontWeight: "bold",
    paddingVertical: 8,
    paddingHorizontal: 16,
    fontFamily: "monospace",
    color: "white",
    textAlign: "center",
    borderColor: "#00796B", // Color del borde
    borderRadius: 5,
    marginBottom: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    fontFamily: "monospace",
  },

  tableScroll: {
    flexGrow: 1,
  },
  tableItem: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#CCCCCC",
  },
  selectedItem: {
    backgroundColor: "#A1B9BF",
  },
  tableItemText: {
    color: "#111111",
    fontSize: 16,
    flex: 1,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "monospace",
  },
  modalTextModalCargaFabrica: {
    fontSize: 16,
    color: "#111111",
    marginBottom: 8,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "monospace",
    backgroundColor: "#cbcbcb",
    padding: 5,
    marginLeft: 0,
    marginRight: 0,
    borderRadius: 0,
    borderWidth: 1,
    borderColor: "#ddd",
  },
  tableItemTextWhite: {
    color: "white",
    fontSize: 16,
    flex: 1,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "monospace",
  },
  tableHeaderMO: {
    color: "white",
    fontSize: Platform.OS === "web" ? 16 : 13,
    flex: 1,
    flexDirection: "row",
    textAlign: "center",
    paddingLeft: 2,
    paddingRight: 2,
    fontFamily: "monospace",
  },
  button: {
    backgroundColor: "#2a373c",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 12,
    margin: 5,
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },

  buttonCerrarImgCalidad: {
    marginTop: 5,
    borderRadius: 5,
    backgroundColor: "#a1b9bf",
    marginHorizontal: 5,
    width: "20%",
    height: "4%",
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },
  buttonCountGr: {
    fontFamily: "monospace",
    backgroundColor: "#2a373c",
    fontSize: 16,
    fontWeight: "bold",
    paddingVertical: 8,
    paddingHorizontal: 16,
    color: "white",
    textAlign: "center",
    borderColor: "#00796B", // Color del borde
    borderRadius: 5,
    marginBottom: 10,
    shadowColor: "#000",
    marginLeft: 5,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },

  buttonText: {
    fontFamily: "monospace",
    color: "white",
    fontSize: 16,
  },

  tableHeader: {
    //backgroundColor: "#333",
    flexDirection: "row",
    padding: 8,
    alignItems: "center",
  },

  headerText: {
    fontFamily: "monospace",
    color: "white",
    fontSize: 16,
    flex: 1,
    flexDirection: "row",
    textAlign: "center",
  },
  infoItem: {
    alignItems: "center",
    textAlign: "center",
    Width: "5%",
    backgroundColor: BRAND_COLORS.ACCENT,
    margin: 3,
    padding: 3,
    borderRadius: 5,
    shadowColor: "#000",
    marginLeft: 5,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },

  infoText: {
    fontFamily: "monospace",
    fontWeight: "bold",
    fontSize: 15,
    color: "#F9F9F9",
  },
  isSelectedMo: {
    color: "#2b4f60",
    fontWeight: "bold",
    fontFamily: "monospace",
  },

  headerTextAgrup: {
    fontFamily: "monospace",
    color: "white",
    textAlign: "center",
    fontSize: 16,
    padding: 8,
  },

  line: {
    height: 1,
    backgroundColor: "gray",
    marginVertical: 5,
  },

  borrarButtonText: {
    fontFamily: "monospace",
    color: "#f3ff65",
    fontSize: 16,
    fontWeight: "bold",
  },

  modalContainer: {
    flex: 1,
    backgroundColor: "rgba(69, 99, 105, 0.4)", // Verde oliva con transparencia (#456369)
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 20,
  },
  modalContent: {
    backgroundColor: "#223134", // Color de fondo #456369
    padding: 20,
    borderRadius: 10,
    marginHorizontal: 20, // Añade margen horizontal
    marginTop: 100,
    marginBottom: 200,
  },
  modalText: {
    fontSize: Platform.OS === "web" ? 18 : 14,
    color: "white",
    marginBottom: 8,
    textAlign: "center",
    fontFamily: "monospace",
  },
  modalTextSub: {
    fontSize: 15,
    color: "white",
    marginBottom: 8,
    fontFamily: "monospace",
    textAlign: "center",
  },

  buttonModalContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginTop: 10,
  },

  inputRef: {
    borderWidth: 1,
    marginBottom: 10,
    paddingVertical: 8,
    color: "Black",
    backgroundColor: "#c7d7e0", //"rgba(213, 221, 213, 0.5)", // Utiliza el valor RGBA para establecer la transparencia
    justifyContent: "center",
    alignItems: "center",
    borderColor: "rgba(0, 0, 0, 0.5)",
    paddingHorizontal: 10,
    fontSize: 16,
    borderRadius: 5,
    fontFamily: "monospace",
  },

  inputCode: {
    borderWidth: 1,
    marginBottom: 10,
    paddingVertical: 8,
    color: "white",
    backgroundColor: "rgba(213, 221, 213, 0.5)", // Utiliza el valor RGBA para establecer la transparencia
    justifyContent: "left",
    alignItems: "left",
    borderColor: "rgba(0, 0, 0, 0.5)",
    paddingHorizontal: 10,
    fontSize: 16,
    borderRadius: 5,
  },

  searchButton: {
    margin: 8,
  },

  FilasStyle: {
    borderWidth: 1,
    marginBottom: 6,
    paddingVertical: 4,
    color: "white",
    backgroundColor: "#c7d7e0", //"rgba(213, 221, 213, 0.5)", // Utiliza el valor RGBA para establecer la transparencia
    justifyContent: "center",
    alignItems: "center",
    borderColor: "rgba(0, 0, 0, 0.5)",
    paddingHorizontal: 10,
    fontSize: 16,
    borderRadius: 5,
  },

  FilasStyleStatus: {
    borderWidth: 1,
    marginBottom: 6,
    color: "white",
    backgroundColor: "rgba(213, 221, 213, 0.5)",
    justifyContent: "center",
    alignItems: "center",
    borderColor: "rgba(0, 0, 0, 0.5)",
    borderRadius: 5,
  },

  buttonAddWeightDisabled: {
    backgroundColor: "#555", // Color de fondo apagado
    fontFamily: "monospace",
    fontSize: 16,
    fontWeight: "bold",
    paddingVertical: 8,
    paddingHorizontal: 12,
    textAlign: "center",
    borderColor: "#666", // Color del borde apagado
    borderRadius: 5,
    shadowColor: "#000",
    marginLeft: 5,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 0, //
  },

  buttonAddWeight: {
    backgroundColor: "#2a373c",
    fontFamily: "monospace",
    fontSize: 16,
    fontWeight: "bold",
    paddingVertical: 8,
    paddingHorizontal: 12,
    textAlign: "center",
    borderColor: "#00796B", // Color del borde
    borderRadius: 5,
    shadowColor: "#000",
    marginLeft: 5,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },

  buttonDetails: {
    fontSize: 16,
    height: 40,
    backgroundColor: BRAND_COLORS.ACCENT,
    color: "white",
    margin: 5,
  },

  marginTitleAddWeight: {
    backgroundColor: "#2a373c",
    fontSize: 16,
    fontWeight: "bold",
    paddingVertical: 8,
    paddingHorizontal: 12,
    textAlign: "center",
    fontFamily: "monospace",
  },

  inputWeightContainer: {
    // flex: 1,
    width: "10%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 5,
    padding: 5,
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 3,
    elevation: 4,
  },
  inputWeight: {
    width: "100%",
    textAlign: "center",
    fontFamily: "monospace",
  },
  marginInputWeightContainer: {
    // flex: 1,
    width: "10%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 5,
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: "#2a373c",
  },

  spaceBlanck: {
    backgroundColor: "",
    paddingVertical: 8,
    paddingHorizontal: 26,
    textAlign: "center",
    flex: 0.4,
  },

  pickerItemStyle: {
    borderWidth: 1,
    marginBottom: 10,
    paddingVertical: 8,
    color: "black",
    backgroundColor: "rgba(213, 221, 213, 0.5)", // Utiliza el valor RGBA para establecer la transparencia
    justifyContent: "center",
    alignItems: "center",
    borderColor: "rgba(0, 0, 0, 0.5)",
    paddingHorizontal: 10,
    fontSize: 16,
    borderRadius: 5,
  },
  cardDR: {
    padding: 5,
    marginTop: 10,
    width: "100%",
    backgroundColor: "#68848d",
    justifyContent: "normal",
    height: "70px",
    borderRadius: 8,
    shadowColor: "#000",
    borderColor: "#1e352b",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
    elevation: 5,
    flexDirection: "row", // Cambiado a columna para que los elementos se apilen verticalmente
  },
  rowDR: {
    alignItems: "center",
    fontSize: "15px",
    padding: 1,
    flex: 1,
    marginLeft: "1%", // Cambiado de 0 para espaciar los elementos
  },

  inputDR: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 4,
    // padding: 5,
  },
  touchableRD: {
    backgroundColor: "#294f36",
    justifyContent: "center",
    alignItems: "center",
    padding: 0, // Cambié "10px" a 10 (sin comillas)
    height: 45,
    width: 55,
    margin: 10, // Cambié "10px" a 10 (sin comillas)
    borderRadius: 8,
    borderWidth: 2, // Agregado: ancho del borde
    borderColor: "#1e352b", // Agregado: color del borde (un tono más oscuro)
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
  },

  checkRB: {
    width: 20,
    justifyContent: "center",
    alignItems: "center",
    padding: 10, // Cambié "10px" a 10 (sin comillas)
    margin: 10, // Cambié "10px" a 10 (sin comillas)
  },
  inputsDR: {
    fontFamily: "monospace",
    height: 30,
    width: "80%",
    backgroundColor: "white",
    borderColor: "#456369",
    borderRadius: 8,
    color: "Black",
  },

  tableCell: {
    flex: 1, // Ajusta esto según sea necesario
    borderWidth: 1,
    borderColor: "black",
    padding: 5,
    alignContent: "center",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 15,
    flexDirection: "row",
  },

  tableSubCell: {
    flex: 1, // Ajusta esto según sea necesario
    borderWidth: 1,
    backgroundColor: "#A8D5BA",
    borderColor: "black",
    padding: 5,
    alignContent: "center",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 15,
    flexDirection: "row",
  },

  buttonDailyTitle: {
    color: "Black",
    fontWeight: "bold",
    alignContent: "center",
    textAlign: "center",
    fontFamily: "monospace",
    alignItems: "center",
    fontSize: 16,
  },

  inputsMenu: {
    color: "white",
    fontWeight: "bold",
    textShadowColor: "rgba(0, 0, 0, 0.75)",
    fontFamily: "monospace",
    textShadowOffset: { width: -1, height: 1 },
    textShadowRadius: 10,
  },

  encabezadoTablaDetail: {
    justifyContent: "center",
    backgroundColor: "#E8F2EF",
    marginTop: 10,
    width: "100%",
    zIndex: -1,
  },

  rowEncabezadoTablaDetail: {
    width: "100%",
    flexDirection: "row",
    backgroundColor: "#294f36",
    width: "100%",
    zIndex: -1,
  },
  rowEncabezadoStyle: {
    borderTopEndRadius: 10,
    borderTopStartRadius: 10,
    flexDirection: "row",
    padding: 10,
    backgroundColor: "#ddd",
    width: "100%",
  },
  titleEncabezadoStyle: {
    flex: 1,
    fontWeight: "bold",
    textAlign: "center",
    fontFamily: "monospace",
    fontSize: 16,
  },
  styleTextRow: {
    flex: 2,
    color: "#333333",
    fontFamily: "monospace",
  },
  styleTextRowTwo: {
    flex: 1,
    color: "#333333",
    fontFamily: "monospace",
  },
  containerRepairScreen: {
    flex: 1,
    // backgroundColor: BRAND_COLORS.ACCENT,
  },
  tableRepairScreen: {
    flex: 1,
    borderRadius: 10,
    margin: 15,
    border: 5,
    backgroundColor: "white",
  },

  headerRowRepairScreen: {
    borderTopEndRadius: 10,
    borderTopStartRadius: 10,
    flexDirection: "row",
    padding: 10,
    backgroundColor: "#cbcbcb",
    borderBottomWidth: 0.1,
  },
  headerCellRepairScreen: {
    flex: 0.8,
    fontWeight: "bold",
    textAlign: "center",
    fontFamily: "monospace",
    marginTop: 0,
    fontSize: 17,
  },
  headerCellClienteRepairScreen: {
    flex: 2,
    fontWeight: "bold",
    textAlign: "center",
    fontFamily: "monospace",
  },
  cellRepairScreen: {
    flex: 0.8,
    textAlign: "center",
    fontFamily: "monospace",
    fontSize: 16,
  },

  headerCellCargaDeFabricaScreen: {
    fontWeight: "bold",
    textAlign: "center",
    fontFamily: "monospace",
    marginTop: 0,
    fontSize: 17,
  },

  headerCellClienteCargaDeFabricaScreen: {
    flex: 2,
    fontWeight: "bold",
    textAlign: "center",
    fontFamily: "monospace",
    backgroundColor: "#cbcbcb",
    flexDirection: "row",
  },
  cellCargaDeFabricaScreen: {
    flex: 0.8,
    textAlign: "center",
    fontFamily: "monospace",
    fontSize: 16,
  },
  headerRowCargaDeFabricaScreen: {
    borderTopEndRadius: 10,
    borderTopStartRadius: 10,
    flexDirection: "row",
    padding: 10,
    backgroundColor: "#cbcbcb",
    borderBottomWidth: 0.1,
  },
  cellClienteRepairScreen: {
    flex: 2,
    fontWeight: "bold",
    fontFamily: "monospace",
    textAlign: "center",
    borderTopColor: 1,
    backgroundColor: "#dedede",
  },
  rowRepairScreen: {
    flexDirection: "row",
    borderTopColor: "#b9b9b9",
    borderTopWidth: 0.5,
    borderBottomWidth: 0.5,
    borderBottomColor: "#b9b9b9",
  },
  scrollViewRepairScreen: {
    flex: "75vh",
    borderBottomStartRadius: 10,
    borderBottomEndRadius: 10,
  },

  ruedaActividad: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.25)",
  },
  overlay: {
    padding: 20,
    borderRadius: 10,
    backgroundColor: "rgba(0,0,0,0.75)",
    justifyContent: "center",
    alignItems: "center",
  },

  smallText: {
    fontFamily: "monospace",
    fontSize: 12,
  },
  smallTextDos: {
    fontFamily: "monospace",
    fontSize: 15,
  },
  headerRowCargaFabricaScreen: {
    borderTopEndRadius: 10,
    borderTopStartRadius: 10,
    flexDirection: "row",
    padding: 10,
    backgroundColor: "#cbcbcb",
    borderBottomWidth: 0.1,
  },
  headerCellCargaFabricaScreen: {
    flex: 0.8,
    fontWeight: "bold",
    textAlign: "center",
    fontFamily: "monospace",
    marginTop: 0,
    fontSize: 17,
  },
  scrollViewCargaFabricaScreen: {
    flex: "75vh",
    borderBottomStartRadius: 10,
    borderBottomEndRadius: 10,
  },
  rowCargaFabricaScreen: {
    flexDirection: "row",
    borderTopColor: "#b9b9b9",
    borderTopWidth: 0.5,
    borderBottomWidth: 0.5,
    borderBottomColor: "#b9b9b9",
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center", // Centrar verticalmente
    alignItems: "center", // Centrar horizontalmente
  },
  loadingImage: {
    width: 40,
    height: 40,
    // backgroundColor: "rgba(0, 0, 0, 0.9)",
    // borderRadius: 50,
  },
  loadingImageDos: {
    width: 15,
    height: 15,
    // backgroundColor: "rgba(0, 0, 0, 0.9)",
    // borderRadius: 50,
  },
});
